/* The native selector updates the gallery, price, SKU, URL and cart variant.
   Extend its completed-render event with the pilot's variant metafields. */
(() => {
  if (window.rokVariantPilotSubscribed) return;
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  window.rokVariantPilotSubscribed = true;
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const section = document.getElementById(`shopify-section-${data.sectionId}`);
    if (!section?.querySelector('[data-rok-pilot]')) return;
    section.querySelectorAll('[data-rok-fragment]').forEach((destination) => {
      const source = data.html.querySelector(`[data-rok-fragment="${destination.dataset.rokFragment}"]`);
      if (!source) return;
      destination.innerHTML = source.innerHTML;
      destination.hidden = source.hidden;
      if (source.hasAttribute('data-rok-blocked')) {
        destination.dataset.rokBlocked = source.dataset.rokBlocked;
      }
    });
    const button = section.querySelector('[name="add"]');
    const sourceButton = data.html.getElementById(`ProductSubmitButton-${data.sectionId}`);
    if (button && sourceButton) {
      button.disabled = sourceButton.disabled;
      button.setAttribute('aria-label', sourceButton.getAttribute('aria-label')?.trim() || '');
      const label = button.querySelector('span');
      const sourceLabel = sourceButton.querySelector('span');
      if (label && sourceLabel) label.textContent = sourceLabel.textContent;
    }
    syncPilotVariantGallery(section, data.html);
  });
  const syncPilotVariantGallery = (section, sourceDocument = null) => {
    if (!section?.querySelector('[data-rok-pilot]')) return;
    const destination = section.querySelector('[data-rok-pilot-gallery]');
    const source = sourceDocument?.querySelector?.('[data-rok-pilot-gallery]');
    if (destination && source) {
      destination.innerHTML = source.innerHTML;
    }
  };

  const syncPilotTierVisibility = (section) => {
    if (!section?.querySelector('[data-rok-pilot]')) return;
    const tier = section.querySelector('[data-rok-tier-variant-id]');
    if (!tier) return;
    const variantId =
      section.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value ||
      '';
    tier.hidden = String(variantId) !== String(tier.dataset.rokTierVariantId);
  };

  document.addEventListener('variantChangeEnd', (event) => {
    const section = event.target.closest('.product-section');
    syncPilotTierVisibility(section);
    requestAnimationFrame(() => syncPilotVariantGallery(section));
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-section').forEach((section) => {
      if (!section.querySelector('[data-rok-pilot]')) return;
      syncPilotTierVisibility(section);
      syncPilotVariantGallery(section);
    });
  });

  document.addEventListener('submit', (event) => {
    const section = event.target.closest('.product-section');
    if (!section?.querySelector('[data-rok-pilot]')) return;
    if (!event.target.matches('form[data-type="add-to-cart-form"]')) return;
    const button = event.target.querySelector('[name="add"]');
    if (button?.disabled || section.querySelector('[data-rok-blocked="true"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-rok-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-rok-pilot-gallery]');
    const image = gallery?.querySelector('[data-rok-gallery-main-image]');
    const link = gallery?.querySelector('[data-rok-gallery-main-link]');
    if (!gallery || !image) return;

    const src = thumb.dataset.src;
    const alt = thumb.dataset.alt || '';
    if (src) {
      image.src = src;
      image.removeAttribute('srcset');
      if (link) link.href = src;
    }
    image.alt = alt;
    gallery.querySelectorAll('[data-rok-gallery-thumb]').forEach((item) => {
      item.classList.toggle('is-active', item === thumb);
      item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
    });
  });
})();
